export default "__VITE_ASSET__738533c8__"